export default [
  {
    path: "/wt-activity-detail/:code",
    name: "ActivityDetail",
    meta: {
      title: "活动专区",
      showHeader: true,
      showCart: true
    },
    component: () =>
      import(
        /* webpackChunkName: "activity" */ "@/views/activity/ActivityDetail.vue"
      )
  }
];
